import {Component, ChangeDetectionStrategy} from '@angular/core';
import {LoginService} from './login.service';

@Component({
    selector: 'ctv-logout',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutComponent {

  constructor(private loginService: LoginService) {
    loginService.logout();
  }

}
